import {Pipe, PipeTransform} from '@angular/core';
import {CodebookModel} from '../models/codebook.model';
import {DocumentTypeCodebook} from '../codebook/document-type-codebook';

@Pipe({
    name: 'documentType'
})
export class DocumentTypePipe implements PipeTransform {
    private allTypes:CodebookModel[] = DocumentTypeCodebook.allTypes;
    constructor() {
    }


    transform(value: any, args?: any): any {

        let  type = this.allTypes.filter(type => type.id === value)[0];
        if(type == null) {
            type = {id:-1,name:'n/a'}
        }
        return type.name;
    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/pipes/documentType.pipe.ts